/**
 * User: Rob Richard
 * Date: 5/30/14
 * Time: 2:39 PM
 */

'use strict';
var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var Clump = require('bunsen/libraries/clump');
var Party = require('bunsen/models/Party');
var Note = require('bunsen/models/Note');
var baseTransitionMixin = require('bunsen/models/mixins/transitionMixin');



module.exports = {
    transition: function (status, passedOptions) {
        this.set('status', status);
        return baseTransitionMixin.transition.call(this, passedOptions);
    },
    updateAndTransition: function (status, passedOptions) {
        this.set('status', status);
        return baseTransitionMixin.updateAndTransition.call(this, passedOptions);
    },
    update: function (status, passedOptions) {
        return baseTransitionMixin.update.call(this, passedOptions);
    },
    /**
     * Transitions the document and anchors a note
     * @param {string} status to transition to
     * @param {object} passedOptions
     * @param passedOptions.noteContent
     * @param passedOptions.noteRole The note role
     * @param passedOptions.noteType The note type
     * @returns {$.Deferred.promise}
     */
    transitionWithNote: function (status, passedOptions) {
        var clump = new Clump();
        var saves = this._clumpTransitionWithNote(clump, status, passedOptions);
        clump.run({dynaOptions: {
            open: '___',
            close: '___',
            params: {
                anchorId: {
                    clumpElement: "transition",
                    expression: "$.result.id"
                }
            }
        }});
        return $.when.apply($, saves);
    },
    /**
     * @private
     * @param {Clump} clump
     * @param {string} status
     * @param {object} passedOptions Options representing new note attributes
     * @returns {$.deferred.promise[]}
     */
    _clumpTransitionWithNote: function (clump, status, passedOptions) {
        var saves = [];
        var note;
        var saveNote = false;
        var options = _.extend({
            clump: clump,
            clumpName: 'transition',
            clumpProfile: 'transition',
            transitionFunction: 'transition'
        }, passedOptions);

        // Save Note
        if (options.noteContent) {
            note = this.newNote({
                content: options.noteContent,
                role: options.noteRole,
                type: options.noteType
            });
            if (this.isNew()) {
                note.setAnchorId(this.anchorType, '___anchorId___');
            }
            if (options.saveNoteFirst) {
                saves.push(note.save(null, { clump: clump }));
            } else {
                saveNote = true;
            }
        }

        // Transition self
        saves.push(this[options.transitionFunction](status, options));

        // the note MUST be saved after the transition for the dynaparam anchor id
        // to work
        if (saveNote && !options.saveNoteFirst) {
            saves.push(note.save(null, { clump: clump }));
        }
        return saves;
    },
    /**
     * Transition this model while taking action on an offer at the same time
     * @param status {String} status to transition this model to
     * @param passedOptions options for this function described below
     * @param passedOptions.offer {Object} offer to accept or counter
     * @param passedOptions.counterOffer {Object} offer to counter with, null if accepting
     * @param passedOptions.noteContent {Object} note to anchor to the counter offer
     * @param passedOptions.noteRole {Object} note to anchor to the counter offer
     * @param passedOptions.noteType {Object} note to anchor to the counter offer
     */
    transitionWithOfferNote: function (status, passedOptions) {
        var saves = [];
        var options = passedOptions || {};
        var dynaOptions;
        var clump = new Clump();

        if (!!options.noteContent) {
            dynaOptions = {
                open: '___',
                close: '___',
                params: {
                    anchorId: {
                        clumpElement: "transition",
                        expression: "$.result.id"
                    },
                    counterOfferId: {
                        clumpElement: "counterOffer",
                        expression: "$.result.counterOfferId"
                    }
                }
            };
        }

        if (options.counterOffer) {
            saves = options.offer.clumpCounterOfferNote(clump, options);
            // Note has been saved, remove it so it is not saved when this is transitioned
            options.noteContent = undefined;
        } else {
            if (!passedOptions.offer.isAccepted()) {
                saves = [options.offer.accept({clump: clump})];
            }
        }
        saves.push(this._clumpTransitionWithNote(clump, status, options));
        clump.run({dynaOptions: dynaOptions});
        return $.when.apply($, _.flatten(saves));
    },
    dealerTransitionWithOfferNote: function (status, offer, counterOffer, passedOptions) {
        var options = _.extend({
            offer: offer,
            counterOffer: counterOffer,
            noteRole: Party.ROLE_SELLER,
            noteType: Note.TYPE_BUYER_SELLER
        }, passedOptions);
        return this.transitionWithOfferNote(status, options);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/ecomm/transitionMixin.js
// module id = 19
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55